// removed by extract-text-webpack-plugin
module.exports = {"searchBar":"_2_ZAy3_p"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/searchbar/searchbar.styles.scss
// module id = 759
// module chunks = 0